// extracted by mini-css-extract-plugin
module.exports = {"link":"_0a3a94f455--link--xaKpq","link--phone":"_0a3a94f455--link--phone--goh_E","link-disabled":"_0a3a94f455--link-disabled--KZiA6"};